export default {
  UNITS: (state) => state.units,
  GET_UNITS_DATA: (state) => state.units,
};
